import Modal from '../../components/ui/Modal.jsx';
import InvitadoForm from '../../components/InvitadoForm.jsx';

// Modal wrapper around <InvitadoForm/> used by the AdminInvitados page.
// Extracted from AdminInvitados so the form can be reused or tested
// independently.
export default function AdminInvitadoForm({
  open,
  mode = 'create',
  defaultValues,
  onSubmit,
  onClose,
  isSubmitting,
}) {
  const title = mode === 'edit' ? 'Editar invitado' : 'Agregar invitado';

  return (
    <Modal open={open} onClose={onClose} title={title} ariaLabel={title}>
      <InvitadoForm
        mode={mode}
        defaultValues={defaultValues}
        onSubmit={async (payload) => {
          await onSubmit(payload);
        }}
        onCancel={onClose}
        submitLabel={mode === 'edit' ? 'Guardar cambios' : 'Crear invitado'}
      />
      {isSubmitting && <span className="sr-only">Guardando</span>}
    </Modal>
  );
}